export default {
  props: {
    isForceStart: {
      type: Boolean,
      default: false
    },
    questionnaireType: {
      type: String,
      default: 'normal'
    },
    mockOptions: {
      type: Object,
      default: null
    }
  }
};
